import { React, useEffect } from "react";
import { Link } from 'react-router-dom';
import UserContextProvider from "../contexts/UserContext";
import SubscriptionPageForm from "../components/SubscriptionPageForm";

const FailurePage = () => {

	return (
		<UserContextProvider>
		<div className="flex flex-col items-center justify-center min-h-screen bg-gray-200">
		  <h1 className="text-2xl font-bold mb-4 text-red-500">Payment Failed</h1>
		  <p className="text-center mb-4">
			We're sorry, but your payment could not be processed at this time.
		  </p>
		  <p className="text-center mb-4">
			Please double-check your payment information or try again later.
		  </p>
		  <a href="https://www.hopguides.com/pricing" className="text-blue-500">
			Retry Payment
		  </a>
		</div>
	  </UserContextProvider>
	);
};

export default FailurePage;

